import { render, staticRenderFns } from "./HighlightPreviewControllerParts.vue?vue&type=template&id=0fa3d764&scoped=true"
import script from "./HighlightPreviewControllerParts.vue?vue&type=script&lang=ts"
export * from "./HighlightPreviewControllerParts.vue?vue&type=script&lang=ts"
import style0 from "./HighlightPreviewControllerParts.vue?vue&type=style&index=0&id=0fa3d764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa3d764",
  null
  
)

export default component.exports